import { Link } from "react-router-dom";
import Loader from "../../../components/atoms/Loader";
import {
  BreadCrumbItem,
  BreadcrumbItem,
  Breadcrumbs,
} from "../../../components/general/Breadcrumbs";
import { useQueryError } from "../../../hooks/http/useQueryError";
import { useFlashMessage } from "../../../hooks/useFlashMessage";
import SectionInterface from "../../../interfaces/SectionInterface";
import StudentFollowPromptForm from "./StudentFollowPromptForm";
import type { StudentFollowPromptFormValues } from "./StudentFollowPromptForm/validationSchema";
import { useFetchStudentFollowPrompt } from "./useFetchStudentFollowPrompt";
import { useUpdateStudentFollowPrompt } from "./useUpdateStudentFollowPrompt";

interface Props {
  section: SectionInterface;
}

// BreadCrumbItem で包むことで、Breadcrumbs が意図する「Separator との間隔 10px」を適用する
// （BreadcrumbsView は包んでおらず Figma より間隔が詰まるため使わない）
const renderBreadcrumbItem = (item: BreadcrumbItem) => (
  <BreadCrumbItem>
    {item.url ? <Link to={item.url}>{item.label}</Link> : item.label}
  </BreadCrumbItem>
);

const SectionsStudentFollowPrompt = ({ section }: Props) => {
  const { showSuccessMessage, showErrorMessage } = useFlashMessage();

  const { data, isPending, error } = useFetchStudentFollowPrompt({
    sectionId: section.id,
  });
  useQueryError(error);

  const updateMutation = useUpdateStudentFollowPrompt({
    sectionId: section.id,
  });

  const handleSubmit = (values: StudentFollowPromptFormValues) => {
    updateMutation.mutate(values, {
      onSuccess: () => {
        showSuccessMessage("プロンプト設定を登録しました");
      },
      onError: () => {
        // 403（verify_ai_assistant_available）を含む失敗の防御的ハンドリング。入力内容は保持される
        showErrorMessage("プロンプト設定を登録できませんでした");
      },
    });
  };

  return (
    <div>
      <div className="flex h-[4.4rem] items-center">
        <Breadcrumbs
          items={[
            {
              label: "AIアシスタントサマリー",
              url: `/sections/${section.id}/student_follow_summaries`,
            },
            { label: "プロンプト設定" },
          ]}
        >
          {renderBreadcrumbItem}
        </Breadcrumbs>
      </div>
      {data && (
        <StudentFollowPromptForm
          prompt={data.prompt}
          submitting={updateMutation.isPending}
          onSubmit={handleSubmit}
        />
      )}
      <Loader loading={isPending} />
    </div>
  );
};

export default SectionsStudentFollowPrompt;
